export const Strategy = Object.freeze({
  ProductPage: 'productPage'
});
